import { Tabs } from '@mantine/core';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isLoggedinUserAdminSelector, setSpeciesModelOptions } from '../../store/slices/appSlice';
import { extractModelInformation } from './helpers';
import { getDataModelList } from '../../services/aws';

import useAuthenticate from '../../customHooks/authenticate';

import useGetSpeciesData from '../../customHooks/useGetSpeciesData';

import CreateModelGenusS3Data from './CreateModelGenusS3Data/CreateModelGenusS3Data';
import ModalNotificationComponent from './ModalNotificationComponent/ModalNotificationComponent';
import DeleteModelGenusS3Data from './DeleteModelGenusS3Data/DeleteModelGenusS3Data';
import GlobalLoader from '../../components/GlobalLoader/GlobalLoader';
import AddRecordModal from '../../components/Modals/AddRecordModal/AddRecordModal';
import GenusSampleContent from './GenusSampleContent/GenusSampleContent';
import DataModelsComponent from './DataModelsComponent/DataModelsComponent';
import PreviousVersionDataModel from './PreviousVersionDataModel/PreviousVersionDataModel';

import './Admin.css';

const DataModelContent = () => {
  return (
    <div className='DataModelContent'>
      <Tabs color='#5cb282' defaultValue='update'>
        <Tabs.List>
          <Tabs.Tab size={20} color='#2c8457' value='update'>
            Update
          </Tabs.Tab>
          <Tabs.Tab value='add'>Add</Tabs.Tab>
          <Tabs.Tab value='delete'>Delete</Tabs.Tab>
          <Tabs.Tab value='restore'>Restore from Previous</Tabs.Tab>
          <Tabs.Tab value='dashboard'>
            <a style={{ color: 'inherit', textDecoration: 'none' }}
              href='https://wfid.maps.arcgis.com/apps/dashboards/b4eed5a57f4d4da19e6fa3f13337cdb4'
              target="_blank"
            >Admin Dashboard</a>
          </Tabs.Tab>
        </Tabs.List>

        <Tabs.Panel value='update'>
          <div className='model-operation-container'>
            <DataModelsComponent />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value='add'>
          <div className='model-operation-container'>
            <CreateModelGenusS3Data />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value='delete'>
          <div className='model-operation-container'>
            <DeleteModelGenusS3Data />
          </div>
        </Tabs.Panel>

        <Tabs.Panel value='restore'>
          <div className='model-operation-container'>
            <PreviousVersionDataModel />
          </div>
        </Tabs.Panel>
      </Tabs>
      <ModalNotificationComponent />
    </div>
  );
};
const TabsComponent = () => {
  const isLoggedinUserAdmin = useSelector(isLoggedinUserAdminSelector);
  return (
    <div className='TabsComponent'>
      <Tabs variant='outline' color='#151515' radius={0} defaultValue='data-models'>
        <Tabs.List>
          <Tabs.Tab value='data-models'>Data Models</Tabs.Tab>
          <Tabs.Tab value='genus-sample'>Genus Sample</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value='data-models'>
          <div className='AdminPage'>
            {isLoggedinUserAdmin && (
              <>
                <h1 className='main-h1'>Species Data Model Management</h1>
                <h3 className='main-h3'>Select a genus to add, restore, or delete species data models.</h3>

                <DataModelContent />
              </>
            )}
          </div>
        </Tabs.Panel>

        <Tabs.Panel value='genus-sample'>
          <div className='AdminPage'>
            {isLoggedinUserAdmin && (
              <>
                <AddRecordModal />
                <GenusSampleContent />
              </>
            )}
          </div>
        </Tabs.Panel>
      </Tabs>
    </div>
  );
};

const AdminPage = () => {
  useGetSpeciesData();
  useAuthenticate();

  const dispatch = useDispatch();

  const getModelData = useCallback(async () => {
    const response = await getDataModelList();
    if (response.success) {
      const result = extractModelInformation(response.data);
      dispatch(setSpeciesModelOptions(result));
    }
  }, [dispatch]);

  useEffect(() => {
    getModelData();
  }, [getModelData]);

  return (
    <div>
      <TabsComponent />
      <GlobalLoader />
    </div>
  );
};

export default AdminPage;
